// extracted by mini-css-extract-plugin
module.exports = {"modal":"PrintLabelModal_modal__3dpz1","buttons":"PrintLabelModal_buttons__3QNaa","primary":"PrintLabelModal_primary__3Djq0"};